<template>
	<div id="Main">
		<div v-if="sharesdata.length>0">
			<div class="box" v-for="(item,index) in sharesdata" :key="index">
				<p class="name">{{item[1]}}</p>
				<div class="content">
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details1.png')" />股权代码</p>
						<p class="data">{{item[0]}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details2.png')" />股权数量</p>
						<p class="data">{{item[2]}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details3.png')" />可用数量</p>
						<p class="data">{{item[3]}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details4.png')" />冻结数量</p>
						<p class="data">{{item[4]}}</p>
					</div>
				</div>
			</div>
		</div>
		<div v-if="type==1">正在更新...</div>
		<div v-if="type==2 && sharesdata.length==0">该账户没有托管股权!</div>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				id:'',
				sharesdata:'',
				tisp:'',
				type:1
			}
		},
		methods: {
			getdata(){
				let t=this;
				let params = '2907;' + this.id + ';;;;;;'
				axiosPost.getdata(params).then((res) => {
					if (res.data.filter && res.data.filter.msg) {
						this.$dialog.alert({
							title: '提示',
							message:res.data.filter.msg,
						}).then(() => {
							if (res.data.filter.code == 0) {
								share()
							}
						});
					}else{
						share()
					}
					function share(){
						let str = res.data.data
						if(res.data.code==200){
							let code = str.slice(0, str.indexOf(';'))
							if (code == 200) {
								str = str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3)
								t.sharesdata = str.split('\\n');
								t.sharesdata.forEach((val, index)=>{
									t.sharesdata[index] = val.split(';');
								});
							} else if (code == 400) {
								// t.$toast({duration:4000,message:'该账户没有托管股权'});
							} else {
								t.$toast({duration:4000,message:str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3) + '，请稍后再试！'});
							}
						}else{
							t.$toast({duration:4000,message:res.data.msg});
						}
						t.type=2;
					}
				}).catch((res) => {
					window.console.log(res)
				})
			}
		},
		mounted(){
			this.id = this.$route.query.id
			this.getdata();
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		min-height: 100vh;
		background-color: #f2f9ff;
		.box{
			background-color: #fff;
			border-radius: 8px;
			padding:0 1rem;
			margin-bottom: 2rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;
			.name{
				text-align: left;
				font-size: 1.8rem;
				color: #333;
				line-height: 3.5rem;
				padding-top: 0.6rem;
				font-weight: bold;
			}
			.content{
				display: flex;
				flex-wrap: wrap;
				.item{
					width: 50%;
					padding: 1rem 0;
					border-top:  1px solid #e0dfdf;
					font-size: 0;
					line-height: 2rem;
					&:nth-child(2n){
						border-left: 1px solid #e0dfdf;
					}
					.title{
						font-size: 1.5rem;
						color: #8c8b8b;
						.icon{
							margin-right: 0.5rem;
							vertical-align: middle;
						}
					}
					.data{
						color: #333333;
						font-size: 1.6rem;
					}
				}
			}
		}
	}
</style>
